import { useMutation } from '@tanstack/react-query';
import { archiveConversation } from '../../services/chats';

interface Options {
  onSuccess?: (archived: boolean) => void | Promise<void>;
  onError?: (archive: boolean) => void | Promise<void>;
}

function useArchiveChat({ onSuccess, onError }: Options = {}) {
  return useMutation({
    mutationFn: async ({
      conversationId,
      archived,
    }: {
      conversationId: string;
      archived: boolean;
    }) => {
      await archiveConversation(conversationId, archived);
      return archived;
    },
    onSuccess,
    onError: (_, { archived }) => onError?.(archived),
  });
}

export default useArchiveChat;
